import { Badge } from "@xola/ui-kit";
import { ICellRendererParams } from "ag-grid-community";
import clsx from "clsx";
import React from "react";
import { InventoryRow, Merchandise } from "types";
import { useAutoFetchCollection } from "@/hooks/useAutoFetchCollection";
import { MERCHANDISE_API_PATH } from "@/models/Merchandise";

const getProductPath = (data: InventoryRow) =>
    data.variantLabel ? `${data.productName} > ${data.variantLabel.split(" / ").join(" > ")}` : data.productName;

const MerchandiseProductTagValue = ({ productId }: { productId: string }) => {
    const { data: merchandises = [] } = useAutoFetchCollection<Merchandise>(MERCHANDISE_API_PATH);
    const product = merchandises.find((m) => m.id === productId);
    return <span>{product?.name ?? productId}</span>;
};

export const MerchandiseInventoryProductCell = ({ data, value, context }: ICellRendererParams<InventoryRow>) => {
    if (context?.target === "tag") {
        return <MerchandiseProductTagValue productId={value as string} />;
    }

    if (!data) {
        return null;
    }

    const productPath = getProductPath(data);

    return (
        <div className="flex h-full items-center gap-2 truncate">
            <span className={clsx("no-translate truncate", data.isDeleted && "text-gray-dark")} title={productPath}>
                {productPath}
            </span>
            {data.isDraft && (
                <Badge color="primary" size="small">
                    Draft
                </Badge>
            )}
            {data.isDeleted && (
                <Badge color="secondary" size="small">
                    Deleted
                </Badge>
            )}
        </div>
    );
};
